module.exports = __webpack_public_path__ + "static/media/marker_selected2.fa9c09df.svg";